export default {
  title: {
    id: 'product_jp_customization_result_seller_info_modal_title',
    defaultMessage: 'Seller information',
  },
  reviews: {
    id: 'product_jp_customization_result_seller_info_modal_reviews_count',
    defaultMessage: `{ count, plural,
      one {# review}
      other {# reviews}
    }`,
  },
  yearsBM: {
    id: 'product_jp_customization_result_seller_info_modal_years_bm',
    defaultMessage: 'Years on Backmarket',
  },
  duration: {
    id: 'product_jp_customization_result_seller_info_modal_duration',
    defaultMessage: '{years} years, {months} months',
  },
  companyName: {
    id: 'product_jp_customization_result_seller_info_modal_company_name',
    defaultMessage: 'Company name: ',
  },
  storeName: {
    id: 'product_jp_customization_result_seller_info_modal_store_name',
    defaultMessage: 'Store name: ',
  },
  address: {
    id: 'product_jp_customization_result_seller_info_modal_address',
    defaultMessage: 'Address: ',
  },
  email: {
    id: 'product_jp_customization_result_seller_info_modal_email',
    defaultMessage: 'Email: ',
  },
  phone: {
    id: 'product_jp_customization_result_seller_info_modal_phone',
    defaultMessage: 'Phone name: ',
  },
  secondhandDealerNumber: {
    id: 'product_jp_customization_result_seller_info_modal_secondhand_dealer_number',
    defaultMessage: 'Secondhand Dealer License Number: ',
  },
  publicSafetyCommission: {
    id: 'product_jp_customization_result_seller_info_modal_public_safety_commission',
    defaultMessage: 'Public Safety Commission: ',
  },
  storeManager: {
    id: 'product_jp_customization_result_seller_info_modal_store_manager',
    defaultMessage: 'Store Manager: ',
  },
  storeSecurityManager: {
    id: 'product_jp_customization_result_seller_info_modal_store_security_manager',
    defaultMessage: 'Store Security Manager: ',
  },
  disclaimer: {
    id: 'product_jp_customization_result_seller_info_modal_disclaimer',
    defaultMessage:
      '*For inquiries, please contact Back Market’s customer support. Directly reaching out to the seller may make it difficult for our support team to assist you properly.',
  },
  buttonLabel: {
    id: 'product_jp_customization_result_seller_info_modal_button_label',
    defaultMessage: 'Shop items from this seller',
  },
}
